import { GroupSetting } from '@griply/types';
import { createContext, useContext } from 'react';
import { ID } from 'shared/types/id';
import { Task } from 'shared/types/task';

export type TypeRenderData = {
  groupSettings: GroupSetting;
  tasksMap: Record<ID, Task>;
  tasks: Task[];
  today: Date;
  defaultNewTaskDate?: Date;
  denseFormat?: boolean;
};

export const TypeRenderDataContext = createContext<TypeRenderData | null>(null);

export const useTypeRenderData = (): TypeRenderData => {
  const data = useContext(TypeRenderDataContext);
  if (!data) {
    throw new Error(
      'useTypeRenderData must be used within a TypeGroupingTasksList',
    );
  }
  return data;
};
